import React, { useState } from 'react';

import { Form, Input, Rate } from 'antd';

type IProps = { form: any };

const SupportQuestions: React.FC<IProps> = ({ form }) => {
    const [first_answer, set_first_answer] = useState(0);
    const [fourth_answer, set_fourth_answer] = useState(0);

    return (
        <>
            <Form.Item
                name="first_answer"
                label="How would you rate your experience with the portal?"
                rules={[{ required: true, message: 'Please rate us' }]}
                data-testid="form-01"
            >
                <Rate value={first_answer} onChange={value => set_first_answer(value)} />
            </Form.Item>

            {form.isFieldTouched('first_answer') && first_answer <= 2 ? (
                <Form.Item
                    name="first_optional_answer"
                    label={'What would you like us to improve?'}
                    rules={[{ required: false }]}
                >
                    <Input data-testid="input-01" />
                </Form.Item>
            ) : null}

            <Form.Item
                name="second_optional_answer"
                label={'What other feedback would you like to share regarding the portal?'}
                rules={[{ required: false }]}
                data-testid="form-04"
            >
                <Input data-testid="input-02" />
            </Form.Item>

            <Form.Item
                name="fourth_answer"
                label="How would you rate your experience with PartsBadger?"
                rules={[{ required: true, message: 'Please rate us' }]}
                data-testid="form-05"
            >
                <Rate value={fourth_answer} onChange={value => set_fourth_answer(value)} />
            </Form.Item>

            {form.isFieldTouched('fourth_answer') && fourth_answer <= 2 ? (
                <Form.Item
                    name="third_optional_answer"
                    label={'Please share more details about your experience'}
                    rules={[{ required: false }]}
                    data-testid="form-06"
                >
                    <Input.TextArea data-testid="input-03" rows={1} />
                </Form.Item>
            ) : null}

            <Form.Item
                name="fourth_optional_answer"
                label={'What other feedback would you like to share regarding PartsBadger?'}
                rules={[{ required: false }]}
                data-testid="form-07"
            >
                <Input.TextArea data-testid="input-04" rows={1} />
            </Form.Item>
        </>
    );
};

export default SupportQuestions;
